import firebase from 'firebase/app'

import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: 'AIzaSyD7sFvpnIDIpfBAU9R1dIdlkYgzoMB6KXA',
    authDomain: 'soniteka-app.firebaseapp.com',
    projectId: 'soniteka-app',
    storageBucket: 'soniteka-app.appspot.com',
    messagingSenderId: '950145036806',
    appId: '1:950145036806:web:5624fd63270b02bc7a0987'
}

firebase.initializeApp(firebaseConfig)

export const serverTimestamp = firebase.firestore.Timestamp

export const firestore = firebase.firestore()
export const storage = firebase.storage()

export const CATEGORIES_COLLECTION = firestore.collection('categories')
export const GAMES_COLLECTION = firestore.collection('games')
export const ORDERS_COLLECTION = firestore.collection('orders')
export const FAQ_COLLECTION = firestore.collection('faq')
export const NEWS_COLLECTION = firestore.collection('news')

export default firebase